import { computed } from 'vue';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { usePolicy } from 'dashboard/composables/usePolicy';

/**
 * Squareme team lead: an agent with the extra `team_lead` permission.
 * Administrators can do everything a team lead can.
 */
export function useTeamLead() {
  const { isAdmin } = useAdmin();
  const { checkPermissions } = usePolicy();
  const isTeamLead = computed(
    () => !isAdmin.value && checkPermissions(['team_lead'])
  );
  return { isAdmin, isTeamLead };
}
